import type { ComponentParts } from '@cli-types/next-adapter/forms.js'
import { buildFieldErrorHelper } from '@next-adapter/generators/form-pipeline/form-component-shared/build-field-error-helper.js'
import { renderFormPipelineBuildComponentSourceRenderer } from '@next-adapter/templates/renderers/generators/form-pipeline/form-component-multistep/build-component-source.js'

export function buildComponentSource(p: ComponentParts): string {
  const providerOpen = renderFormPipelineBuildComponentSourceRenderer({
    kind: 'renderBuildComponentSourceContentTemplate',
    props: { pPascal: p.pascal }
  })
  const exportWrapper = renderFormPipelineBuildComponentSourceRenderer({
    kind: 'renderBuildComponentSourceGeneratedFunctionTemplate',
    props: {
      pPascal: p.pascal,
      providerOpen: providerOpen
    }
  })

  return renderFormPipelineBuildComponentSourceRenderer({
    kind: 'renderBuildComponentSourceClientModuleTemplate',
    props: {
      pHasListFieldsTrash2: p.hasListFields ? ', Trash2' : '',
      pRhfImport: p.rhfImport,
      pPascal: p.pascal,
      pActionImportPath: p.actionImportPath,
      pZodFields: p.zodFields,
      fieldErrorHelper: buildFieldErrorHelper(),
      pStepsConst: p.stepsConst,
      pDefaults: p.defaults,
      pFieldArraySetup: p.fieldArraySetup,
      pWatchSetup: p.watchSetup,
      pSuccessHandler: p.successHandler,
      pSuccessMessage: p.successMessage,
      pStepContentBlocks: p.stepContentBlocks,
      pSubmitText: p.submitText,
      exportWrapper: exportWrapper
    }
  })
}
